import { EmbeddableLocation } from '../EmbeddableLocation';
import { ShipmentStopType } from '../shipment/ShipmentStopType';
import { ShipOrderShippingPoint } from '../ShipOrderShippingPoint';

export class ValidShipOrderShippingPoint extends ShipOrderShippingPoint {
  id: number;
  shippingPointType: ShipmentStopType.PICKUP | ShipmentStopType.DROP_OFF;

  constructor(opts?: Partial<ShipOrderShippingPoint>) {
    super(opts);

    if (opts?.id) {
      this.id = opts.id;
    } else {
      throw new Error('Invalid Shipping Point - id is required');
    }

    if (opts?.location) {
      this.location = new EmbeddableLocation(opts.location);
    } else {
      throw new Error('Invalid Shipping Point - location is required');
    }

    if (opts?.shippingPointType) {
      this.shippingPointType = opts.shippingPointType;
    } else {
      throw new Error('Invalid Shipping Point - shippingPointType is required');
    }
  }
}
